import HBMessage from "@/components/HBMessage";
import { isCancel } from "axios";
import createRequest from "./createRequest";

// yapi、dev、fat、stage、production
const API = {
  yapi: "https://yapi.gaoding.com/mock/1536",
  dev: "https://ke-dev.huaban.com",
  fat: "https://ke-fat.huaban.com",
  stage: "https://ke-stage.huaban.com",
  prod: "https://ke.huaban.com",
};

export const env = process.env.NEXT_PUBLIC_DEPLOY_ENV || "prod";

export const BaseURL = API[env];
export const REQUEST_MESSAGE_KEY = "REQUEST_MESSAGE_KEY";

const axios = createRequest({
  BaseURL,
});

// 公共请求方法
const request = async ({
  url = "/",
  params, // url匹配参数
  query, // 查询参数
  headers = {},
  ignoreMessage,
  ignoreError,
  ignoreCancel,
  serverSideHttps,
  ...opts
}) => {
  try {
    return await axios({
      url,
      params: query,
      options: {
        params,
        ignoreMessage,
        ignoreError,
        ignoreCancel,
      },
      timeout: 10000,
      headers,
      ...(typeof window === "undefined"
        ? {
            ...(!serverSideHttps
              ? { baseURL: BaseURL.replace("https", "http") }
              : null),
          }
        : null),
      ...opts,
    });
  } catch (error) {
    const { response } = error;

    if (
      !ignoreError &&
      typeof window !== "undefined" &&
      (!isCancel(error) || !ignoreCancel)
    ) {
      let errmsg = error.toString();
      if (response?.data && response?.data?.error) {
        errmsg = response.data?.error;
      }

      HBMessage.error({
        content: errmsg,
        key: REQUEST_MESSAGE_KEY,
        duration: 3,
      });

      throw error;
    }
    console.error("error:", error);
  }
};

export default request;
